"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DNDList = void 0;
var react_1 = __importDefault(require("react"));
var style_1 = require("./style");
var mobx_react_1 = require("mobx-react");
exports.DNDList = (0, mobx_react_1.observer)(function (props) {
    var innerRef = props.innerRef, provided = props.provided, value = props.value, children = props.children;
    return (react_1.default.createElement(style_1.StyledDNDList, __assign({ ref: innerRef }, provided.droppableProps, { style: {
            height: "calc(100%".concat((value.allowFilter && ' - 35px') || '', ")")
        } }), children));
});
